import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ConfirmationDialogComponent } from '../configurator/components/confirmation-dialog/confirmation-dialog.component';
import { trigger, transition, style, animate } from '@angular/animations';
import { SharedService } from 'src/app/shared/service/shared.service';
import { DataService } from '../../shared/service/data.service';
import { RequesterService } from './services/requester.service';
import { WasteInfoComponent } from 'src/app/shared/components/waste-info/waste-info.component';
import { CurrencyService } from '../../shared/service/currency.service';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-line-dashboard',
  templateUrl: './line-dashboard.component.html',
  styleUrls: ['./line-dashboard.component.scss'],
  animations: [
    trigger('fillUp', [
      transition(':enter', [
        style({ height: '0' }),
        animate('1s ease-in-out', style({ height: '*' })),
      ]),
    ]),
  ]
})
export class LineDashboardComponent implements OnInit, OnDestroy {

  machineList: any[];
  highestWaste: number;
  filterDatas: any;
  showNoFilterMsg: boolean;
  machineValues = false;
  showInGraph: any = {
    total: true,
    RM: true,
    PM: true,
  };
  emitData: any;
  today = new Date();
  showConfigureCounter = 1;
  noMachines: boolean;
  unitSelected: any;
  unitService: any;
  subscription: Subscription;
  currencyValue: any;
  currencyData: any = {
    currencyRate: '',
    currencyValueCode: ''
  };
  getWasteDataSubscription: Subscription;

  constructor(
    private dialog: MatDialog,
    private sharedservice: SharedService,
    private dataService: DataService,
    private requester: RequesterService,
    private router: Router,
    private currencyService: CurrencyService) {
    this.subscription = currencyService.currencyValue$.subscribe(
      (currencyValue: any) => {
        this.currencyData.currencyRate = currencyValue.crate;
        this.currencyData.currencyValueCode = currencyValue.selectedCurrency.code;
      });
  }

  ngOnInit() {
    // this.checkForSelectedGranularityAndDetail();
    this.dataService.on('lineDBWasteChange', this.showInGraphChanged);
    this.unitService = this.dataService.getUnit().subscribe(message => {
      this.unitSelected = message.text;
    });

    this.dataService.on('getSelectedWaste', this.getSelectedWasteForLine);
    this.dataService.on('currentLink', this.LineSideMenuClicked);
    this.dataService.on('noMatchingParams', this.noMatchingParamsInLine);
  }

  showInGraphChanged = (filterSelection: any) => {
    this.showInGraph = filterSelection;
  }

  LineSideMenuClicked = (item) => {
    if (item === '/line-dashboard') {
      this.showNoFilterMsg = true;
    }
  }

  getSelectedWasteForLine = () => {
    this.checkForSelectedGranularityAndDetail();
  }

  noMatchingParamsInLine = () => {
    this.machineList = [];
    this.showNoFilterMsg = false;
    this.noMachines = true;
  }

  checkForSelectedGranularityAndDetail() {
    const selectedGranularity = JSON.parse(this.dataService.getStorageData('selectedWasteDBGranularity'));
    const selectedetail = JSON.parse(this.dataService.getStorageData('selectedWasteDBDetail'));

    const filterData = {
      visualizationVal: selectedGranularity,
      detailLevel: selectedetail
    };

    if (selectedGranularity && selectedGranularity.line &&
      (selectedGranularity.line.lineId || selectedGranularity.line.id)) {
      let currrentFilter = 'month';
      let currentDate = new Date(this.today.getFullYear(), this.today.getMonth() - 1);
      let currentHour = '';
      let currentEndWeek: any;
      let currentShift = {};

      if (JSON.parse(this.dataService.getStorageData('selectedWasteDBTimeFilter'))) {
        currrentFilter = JSON.parse(this.dataService.getStorageData('selectedWasteDBTimeFilter')).appliedFilterType;
        currentDate = new Date(JSON.parse(this.dataService.getStorageData('selectedWasteDBTimeFilter')).dateObj);

        if (JSON.parse(this.dataService.getStorageData('selectedWasteDBTimeFilter')).selectedHr &&
          JSON.parse(this.dataService.getStorageData('selectedWasteDBTimeFilter')).selectedHr.label) {
          currentHour = JSON.parse(this.dataService.getStorageData('selectedWasteDBTimeFilter')).selectedHr;
        }

        if (currrentFilter === 'week') {
          currentEndWeek = new Date(JSON.parse(this.dataService.getStorageData('selectedWasteDBTimeFilter')).endWeekFromSelectedDate);
        } else {
          currentEndWeek = '';
        }

        if (JSON.parse(this.dataService.getStorageData('selectedWasteDBTimeFilter')).shift) {
          currentShift = JSON.parse(this.dataService.getStorageData('selectedWasteDBTimeFilter')).shift;
        } else {
          currentShift = {};
        }
      }

      this.emitData = {
        timeFilter: {
          appliedFilterType: currrentFilter,
          dateObj: currentDate,
          selectedHr: currentHour,
          endWeekFromSelectedDate: currentEndWeek,
          shift: currentShift
        },
        selectedFilters: filterData
      };

      this.getMachineList(this.emitData);
      // this.setSelectedIdURL();
    } else {
      this.showNoFilterMsg = true;
    }
  }

  openDialog(machineDetails) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;

    dialogConfig.data = machineDetails;

    dialogConfig.height = '85%';
    dialogConfig.width = '65%';
    dialogConfig.panelClass = 'custom-modal-class';
    dialogConfig.autoFocus = false;

    const dialogRef = this.dialog.open(WasteInfoComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(data => {
      // if (!(data === 'closed' || data === 'cancelled')) {
      // this.getMachineList(this.filterDatas);
      // this.setSelectedIdURL();
      // }
    });
  }

  getMachineList(filterData, showReconfigure?: any) {
    this.filterDatas = filterData;
    this.showNoFilterMsg = false;
    this.machineValues = false;
    this.noMachines = false;
    this.machineList = [];

    if (showReconfigure && showReconfigure === 'applyBtn') {
      this.showConfigureCounter = 1;
    }

    this.dataService.setData('lineVisualizationFilter', filterData.selectedFilters.visualizationVal);
    this.dataService.setData('lineDetailFilter', filterData.selectedFilters.detailLevel);

    this.getWasteDataSubscription = this.requester.getWasteData(filterData.selectedFilters.visualizationVal, filterData.selectedFilters.detailLevel,
      filterData.timeFilter)
      .subscribe(result => {
        if (result) {
          if (!result.isAllMachinesBomMapped) {
            if (this.showConfigureCounter === 1) {
              this.openConfirmDialog('lineConfig');
              this.showConfigureCounter++;
            }
          }

          if (result.MachineListWastes && result.MachineListWastes.length) {
            this.totalWasteCalculator(result.MachineListWastes);
            this.machineList = result.MachineListWastes;
          } else {
            this.machineValues = true;
            // this.showNoFilterMsg = true;
            this.noMachines = true;
          }
        } else {
          this.noMachines = true;
        }
      });
  }

  totalWasteCalculator(arr) {
    this.highestWaste = -9999999999;
    let componentMaxVal = -9999999999;

    arr.forEach(machine => {
      machine.rmWaste = 0;
      machine.packageWaste = 0;

      if (machine.waste) {
        machine.waste.forEach(waste => {
          if (waste.type === 'RM') {
            machine.rmWaste = waste.value;
          } else if (waste.type === 'PM') {
            machine.packageWaste = waste.value;
          }
        });
      }

      machine.totalMachineWaste = machine.packageWaste + machine.rmWaste;

      if (this.highestWaste < machine.totalMachineWaste) {
        this.highestWaste = machine.totalMachineWaste;
      }

      if (this.highestWaste < machine.rmWaste) {
        this.highestWaste = machine.rmWaste;
      }

      if (this.highestWaste < machine.packageWaste) {
        this.highestWaste = machine.packageWaste;
      }

      machine.quantity.forEach(item => {
        let componentTotal = 0;
        item.value.forEach(component => {
          if (component && component.value) {
            componentTotal += component.value;
            if (componentMaxVal < component.value) {
              componentMaxVal = component.value;
            }
          }
        });
        item.componentTotal = componentTotal;
      });
    });

    arr.forEach(machine => {
      machine.componentMaxVal = componentMaxVal;
    });
  }

  openConfirmDialog(action: any) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;

    dialogConfig.data = { action };

    dialogConfig.width = '40%';

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'exit') {
        this.router.navigateByUrl('/configurator/filter');
      }
    });
  }

  fliterChange(filterData, showReconfigure?: any) {
    this.filterDatas = filterData;
    this.dataService.setStorageData('selectedWasteDBDetail', JSON.stringify(filterData.selectedFilters.detailLevel));
    this.setSelectedIdURL();
  }

  setSelectedIdURL() {
    let urlParams = '';
    let navUrl = '/waste-dashboard';
    let URL = '';
    const currentUrl = this.router.url;
    const splists = currentUrl.split('/');

    if (this.filterDatas.selectedFilters && this.filterDatas.selectedFilters.visualizationVal) {
      const filterSelection = this.filterDatas.selectedFilters.visualizationVal;
      if (filterSelection.cluster && filterSelection.cluster.id && filterSelection.cluster.name) {
        urlParams = 'clusters/' + filterSelection.cluster.name;

        if (filterSelection.factory && filterSelection.factory.id && filterSelection.factory.name) {
          urlParams = urlParams + '/factories/' + filterSelection.factory.name;

          if (filterSelection.line && filterSelection.line.id && filterSelection.line.name) {
            navUrl = '/line-dashboard';
            urlParams = urlParams + '/lines/' + filterSelection.line.name;
          }
        }
      }
    } else {
      urlParams = '';
      navUrl = '/waste-dashboard';
    }

    if (urlParams) {
      URL = urlParams + navUrl;
    } else {
      URL = navUrl;
    }

    if (navUrl === '/line-dashboard' && navUrl === ('/' + splists[splists.length - 1])) {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate([URL]);
      });
    } else {
      this.router.navigate([URL]);
    }
  }

  ngOnDestroy(): void {
    if (this.unitSelected) {
      this.unitService.unsubscribe();
    }
    if (this.getWasteDataSubscription) {
      this.getWasteDataSubscription.unsubscribe();
    }
    // if (!JSON.parse(this.dataService.getStorageData('selectedWasteDBGranularity')) ||
    //   (JSON.parse(this.dataService.getStorageData('selectedWasteDBGranularity')) &&
    //     !JSON.parse(this.dataService.getStorageData('selectedWasteDBGranularity')).type)) {
    //   this.dataService.removeItemFromStorage('selectedWasteDBGranularity');
    //   this.dataService.removeItemFromStorage('selectedWasteDBDetail');
    // }
  }


}
